import React, { useEffect, useState } from "react";
import {
  Panel,
  Col,
  Row,
  TextBox,
  NewTabLink,
  WaitScreen,
} from "@countysuite/ui";
import { Http } from "utils/Http";
import { GetLOPSummaryTotalsResponse } from "../LackOfProsecutionTypes";

export interface Props {
  definitionID: number;
  exportToCsvUrl: string;
}

export const LackOfProsecutionSummaryPanel: React.FC<Props> = ({
  definitionID,
  exportToCsvUrl,
}) => {
  const exportUrl = `${exportToCsvUrl}?definitionID=${definitionID}&includeContactData=true`;
  const panelButtons = (
    <NewTabLink
      href={exportUrl}
      className="btn btn-primary"
      style={{ color: "white" }}
    >
      Export to CSV
    </NewTabLink>
  );

  const [totalCases, setTotalCases] = useState(0);
  const [totalLetters, setTotalLetters] = useState(0);
  const [totalTerminations, setTotalTerminations] = useState(0);
  const [totalProceeding, setTotalProceeding] = useState(0);
  const [totalUniqueContacts, setTotalUniqueContacts] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getSummaryData() {
      setLoading(true);
      const res = await Http.get<GetLOPSummaryTotalsResponse>({
        url: "LackOfProsecution/GetTotals",
        data: { definitionID },
      });
      if (res.success) {
        setTotalCases(res.totalCases);
        setTotalLetters(res.totalLetters);
        setTotalTerminations(res.totalTerminations);
        setTotalProceeding(res.totalProceeding);
        setTotalUniqueContacts(res.totalUniqueContacts);
      }
      setLoading(false);
    }
    getSummaryData();
  }, [definitionID]);

  return (
    <Panel title="Summary" buttons={panelButtons}>
      <WaitScreen show={loading} message="Loading totals..." />
      <Row>
        <Col xs={12}>
          <h3>Totals</h3>
        </Col>
        <Col xs={6}>
          <TextBox
            readOnly
            name="totalCases"
            label="Cases Found"
            value={totalCases}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <TextBox
            readOnly
            name="totalLetters"
            label="Letters Sent"
            value={totalLetters}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <TextBox
            readOnly
            name="totalTerminations"
            label="Cases Terminated"
            value={totalTerminations}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <TextBox
            readOnly
            name="totalProceeding"
            label="Cases Intending to Proceed"
            value={totalProceeding}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <TextBox
            readOnly
            name="totalUniqueContacts"
            label="Unique Letter Recipients"
            value={totalUniqueContacts}
          />
        </Col>
      </Row>
    </Panel>
  );
};
